"use client";

import { DisclaimerWithReadMore } from "@bfl-ui-toolkit/disclaimer-with-read-more";

interface AMCCalculatorDisclaimerProps {
  disclaimerData: {
    description?: string;
    title?: string;
  };
}

/* eslint-disable react/prop-types */
const AMCCalculatorDisclaimer: React.FC<AMCCalculatorDisclaimerProps> = ({ disclaimerData }) => {
  const heading = disclaimerData.title?.trim() || "Disclaimer";
  const description =
    disclaimerData.description?.trim() ||
    "Keep in mind that the list above is purely informational and not intended as investment advice. It's important to conduct your own research or speak with a financial advisor before making any investment decisions. <span style='font-weight:500;color:#FF6700'>SEBI regulated*</span>";
  const descriptionWithSeBiHighlight = description
    .replace(/<span[^>]*>\s*(SEBI regulated\*?)\s*<\/span>/gi, "$1")
    .replace(/SEBI regulated\*?/gi, "<span style='font-weight:500;color:#FF6700'>$&</span>");

  return (
    <div
      id="calculator-disclaimer"
      data-cmp="AMCCalculatorDisclaimer"
      data-cmp-type="react"
      data-cmp-title="Disclaimer"
    >
      <style>{`
        #calculator-disclaimer .amc-calculator-disclaimer > div {
          padding-left: 0 !important;
          padding-right: 0 !important;
        }

        #calculator-disclaimer .amc-calculator-disclaimer :is(h1, h2, h3, h4, h5, h6) {
          color: #1A1A1A !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          line-height: 100% !important;
        }

        #calculator-disclaimer .amc-calculator-disclaimer p {
          color: #666666 !important;
          font-size: 12px !important;
          font-weight: 400 !important;
          line-height: 120% !important;
        }

        @media (min-width: 768px) {
          #calculator-disclaimer .amc-calculator-disclaimer :is(h1, h2, h3, h4, h5, h6) {
            font-size: 16px !important;
          }

          #calculator-disclaimer .amc-calculator-disclaimer p {
            font-size: 14px !important;
          }
        }
      `}</style>
      <DisclaimerWithReadMore
        content={{
          colorSelection: "transparent",
          description: descriptionWithSeBiHighlight,
          "event-prop-heading": "disclaimer",
          heading,
          isDisclaimerWithReadMore: "false",
          isInfoVariation: "false",
          showOnApp: "true",
          showOnWeb: "true",
          customClass: "amc-calculator-disclaimer",
        }}
      />
    </div>
  );
};

/* eslint-enable react/prop-types */
export default AMCCalculatorDisclaimer;
